<template>
    <side-bar>
        <div class="prod-container">
            <div class="prod-head">
                <div class="prod-title">
                    <span>
                        产品
                        <tip placement="top" :style="{marginLeft: '6px'}"
                             :text="['某一类具有相同能力或特征的设备的合集被称为一款产品']"
                        />
                    </span>
                    <el-button type="primary" size="small" @click="createProduct">创建产品</el-button>
                </div>
                <div class="divider"></div>
                <div class="tips">
                    <i class="el-icon-warning" :style="{fontSize: 32, color: '#438BFF'}"></i>
                    <p>
                        如果您希望使用平台查看设备上报的数据信息，并对设备进行管理控制，就需要开发产品模型(Profile)。定义Profile，使平台理解该款设备支持的属性、命令等信息。根据产品的接入协议、数据格式等可能还需要您定义其他相关的内容。</p>
                </div>
            </div>
            <div class="table-container">
                <div class="divider"></div>
                <el-table :style="{width: '100%'}" height="100%" :data="list">
                    <el-table-column prop="name" label="产品名称" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span class="ellipsis">{{scope.row.name || '-'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="id" label="产品ID" show-overflow-tooltip  width="200">
                        <template slot-scope="scope">
                            <span class="ellipsis">{{scope.row.id || '-'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceType" label="设备类型" show-overflow-tooltip  width="180">
                        <template slot-scope="scope">
                            <span class="ellipsis">{{scope.row.deviceType || '-'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="protocolType" label="协议类型"  width="180">
                        <template slot-scope="scope">
                            <span class="ellipsis">{{scope.row.protocolType | parseProtoText}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150">
                        <template v-slot="{row}">
                            <el-button type="text" @click="read(row)">查看</el-button>
                            <el-button type="text" @click="remove(row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination
                    class="pagination"
                    layout="prev, pager, next, jumper"
                    :page-size="pageSize"
                    :total="total"
                    :current-page="page"
                    @current-change="changePage"
            >
            </el-pagination>
        </div>
    </side-bar>
</template>

<script>
    import sideBar from "../../components/sideBar";
    import tip from "../../components/tip";
    import {mapActions} from 'vuex'
    import {dealErrorCode} from "../../store/server";
    export default {
        name: "productionList",
        components: {
            sideBar,
            tip,
        },
        data() {
            return {
                total: 0,
                page: 1,
                pageSize: 10,
                list: [],
            }
        },
        methods: {
            ...mapActions(['GetProductList', 'DeleteProduct']),
            read(data) {
                this.$router.push({path: '/main/productionInfo', query: {id: data.id}})
            },
            async remove(data) {
                this.$confirm(`确认要删除名为${data.name}的产品吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    closeOnClickModal:false
                }).then(async () => {
                    let res = await this.DeleteProduct(data.id);
                    if (res.code === 1000) {
                        this.$message.success('删除产品成功')
                        await this.getData();
                        if (this.list.length  === 0 && this.page !== 1) {
                            this.page -= 1;
                            await this.getData();
                        }
                    } else if (dealErrorCode(res.code)){
                        this.$message.error('删除产品失败');
                    }
                }).catch(err=>{})
            },
            createProduct() {
                this.$router.push({path: '/create'})
            },
            async getData() {
                let res = await this.GetProductList({
                    page: this.page,
                    limit: this.pageSize,
                })
                if (res.code === 1000) {
                    this.total = res.total;
                    this.list = res.data;
                } else if (dealErrorCode(res.code)){
                    this.$message.error('获取数据失败')
                }
            },
            async changePage(v) {
                this.page = v;
                this.getData();
            }
        },
        created() {
            this.getData();
        }
    }
</script>

<style scoped>
    .prod-container{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 158px 20px 40px;
        box-sizing: border-box;
    }

    .prod-head{
        width: 100%;
        height: 158px;
        box-sizing: border-box;
        padding: 0 20px;
        position: absolute;
        left: 0;
        top: 0;

    }
    .prod-title{
        width: 100%;
        height: 52px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        font-weight: 600;
        box-sizing: border-box;
    }

    .pagination{
        position: absolute;
        bottom: 3px;
        right: 0;
    }
    .table-container{
        width: 100%;
        height: 100%;
    }
</style>